import logger from '@salesforce/retail-react-app/app/utils/logger-instance'

export const doCustomAPICall = async (getTokenWhenReady, params) => {
    try {
        const token = await getTokenWhenReady()
        if (!token) return
        const orgId = params?.config.app?.commerceAPI?.parameters?.organizationId
        const siteId = params?.config.app?.commerceAPI?.parameters?.siteId
        const proxyPath = params?.config.app?.commerceAPI?.proxyPath
        const isHtmlPath = params?.apiPath?.endsWith('/html?')
        let connector = params?.apiPath.includes('?') ? '&' : '?'
        const urlParams = new URLSearchParams()
        urlParams.append('siteId', siteId)
        const apiUrl = `${params?.appOrigin}${proxyPath}/custom/${
            params?.customAPIFolderName
        }/v1/organizations/${orgId}/${params?.apiPath}${connector}${urlParams.toString()}`
        const method = params?.reqParams?.method || 'GET'
        const reqObj = {
            method: method,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            }
        }
        if (params?.reqParams?.reqBody) {
            reqObj.body = JSON.stringify(params?.reqParams?.reqBody)
        }
        const contentResponse = await fetch(apiUrl, reqObj)

        if (contentResponse?.error) {
            logger.error(
                `Error while getting response from ${params?.customAPIFolderName}:`,
                contentResponse.error
            )
            return []
        }

        const data = isHtmlPath ? await contentResponse.text() : await contentResponse.json()
        if (params?.reqParams?.objectTypeId == 'BackInStockNotifications' && method == 'POST') {
            data.status = contentResponse.status
        }

        return data
    } catch (error) {
        logger.error(`${params?.customAPIFolderName} hook error:`, error.message)
        throw error
    }
}

/*
 * This is used to fetch client IP address from server
 */
export const getClinetIP = async (appOrigin) => {
    return await fetch(`${appOrigin}/client-ip`, {
        method: 'GET',
        headers: {'Content-Type': 'application/json'}
    }).then((resp) => {
        return resp.json()
    })
}

export const getSSOCookie = async (appOrigin, cookieName, action = 'get') => {
    const tokenurl = `${appOrigin}/sso-cookie?name=${cookieName}&action=${action}`
    return await fetch(tokenurl, {
        method: 'GET'
    })
        .then((res) => res.json())
        .then((json) => {
            return json
        })
}
